import CourseHeader from '../components/CourseHeader'
import CourseEnroll from '../section/coursedetailspage/CourseEnroll'
import CourseView from '../section/coursedetailspage/CourseView'
import CourseCurriculum from '../section/coursedetailspage/CourseCuriculum'
import CourseBar from '../section/coursedetailspage/CourseBar'
import CourseFooter from '../section/coursedetailspage/CourseFooter'

export default function CourseDetailPage() {
  return (
    <div>
      <CourseHeader />
      <div className="min-h-screen bg-[#F8FAFC] pt-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-12">
          <div className="space-y-6 sm:space-y-10 lg:space-y-10">
            <CourseView />
            <CourseCurriculum />
            <CourseEnroll />
            <CourseBar />
            <CourseFooter />
          </div>
        </div>
      </div>
    </div>
  )
}